import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardBody, Container, Row, Col, Button, Media, Alert } from 'reactstrap';
import { ClipboardCheck, CloudDownload, Link45deg, HandIndex } from 'react-bootstrap-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';
import SimpleHeader from '../../components/Headers/SimpleHeader';
import client from '../../utils/client';
import { getCountry } from '../../utils/helpers';

const country = getCountry()?.toLowerCase();

const campaignMaterial = [
  {
    id: 1,
    name: 'Facebook',
    url: `https://www.golfamore.com/admin-gc/assets/material/banners/${country}-campaign-fb.png`
  },
  {
    id: 2,
    name: 'Instagram',
    url: `https://www.golfamore.com/admin-gc/assets/material/banners/${country}-campaign-ig.png`
  },
  {
    id: 4,
    name: 'A3/A4 pdf',
    url: `https://www.golfamore.com/admin-gc/assets/material/pdf/${country}-campaign-club.pdf`,
    pdf: true
  }
  // {
  //   id: 3,
  //   name: 'Nyhetsbrev',
  //   url: `https://www.golfamore.com/admin-gc/assets/material/banners/${country}-campaign-nl.png`
  // }
];

// const memberOf = country === 'de' ? 'member-golfamore.png' : 'SE-MemberOf.png';
const memberOf = 'member-golfamore.png';

const Material = () => {
  const { t } = useTranslation();

  const [campaign, setCampaign] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    (async () => {
      const { data: cmp } = await client('admin-gc/campaigns');
      if (cmp) {
        setCampaign(cmp);
      }
    })();
  }, []);

  return (
    <>
      <SimpleHeader name={t('material.title', 'Material')} />

      <Container className="mt--6" fluid>
        <Row>
          <Col>
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">{t('material.sub-title', 'Material')}</h3>
                </CardHeader>
                <CardBody>
                  {campaign?.name && (
                    <Row>
                      <Col>
                        <Alert color="secondary" className="mt-3">
                          <HandIndex style={{ fontSize: '2em' }} className="mr-2" />
                          {t('material.campaign-info', {
                            campaignName: campaign.name,
                            campaignStart: campaign.validFrom,
                            campaignEnd: campaign.validTo
                          })}
                        </Alert>
                        {/* eslint-disable-next-line max-len */}
                        {/* 'Kampanjen "{{campaignName}}" gäller mellan {{campaignStart}} och {{campaignEnd}}. Material till kampanjen hittar ni nedan.' */}
                      </Col>
                    </Row>
                  )}

                  {campaignMaterial?.map((c) => (
                    <BannerImage c={c} setCopied={setCopied} copied={copied} />
                  ))}
                </CardBody>
              </Card>
              <Card>
                <CardHeader>{t('material.other-material', 'Övrigt material')}</CardHeader>
                <CardBody>
                  <Row>
                    <Col xs="12">
                      <h3 className="headline">{t('default.brand')} Member of</h3>
                      <Media
                        src={`https://www.golfamore.com/admin-gc/assets/material/banners/${memberOf}`}
                        style={{ width: '120px' }}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="3">
                      <Button
                        href={`https://www.golfamore.com/admin-gc/assets/material/banners/${memberOf}`}
                        target="__blank"
                        className="btn-icon-clipboard btn btn-secondary"
                      >
                        <CloudDownload size={15} className="mr-3" /> {t('material.save-image')}
                      </Button>
                    </Col>
                    <Col sm="3">
                      <CopyToClipboard
                        text={`https://www.golfamore.com/admin-gc/assets/material/banners/${memberOf}`}
                        onCopy={() => setCopied(true)}
                      >
                        <Button
                          className="btn-icon-clipboard ml-0"
                          style={{ paddingTop: '23px', paddingBottom: '23px' }}
                        >
                          <div>
                            {copied ? (
                              <>
                                <ClipboardCheck size={15} className="mr-3" /> {t('default.copied')}
                              </>
                            ) : (
                              <>
                                <Link45deg size={20} className="mr-3" /> {t('material.copy-link')}
                              </>
                            )}
                          </div>
                        </Button>
                      </CopyToClipboard>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Material;

function BannerImage({ c, setCopied, copied }) {
  const { t } = useTranslation();
  return (
    <Row key={c.id} className="mt-3">
      {!c.pdf && (
        <Col xs="12" sm="4">
          <h3 className="mt-3">{c.name}</h3>
          <Media src={c.url} style={{ width: '100%', maxWidth: '500px' }} />
        </Col>
      )}
      <Col xs="12" sm="3" className="d-flex flex-column mt-5">
        {c.pdf && <h3 className="mt-3">{c.name}</h3>}
        <Button href={c.url} target="__blank" className="btn-icon-clipboard btn btn-secondary">
          <CloudDownload size={23} className="mr-3" /> {t('material.save-image', 'Spara ned')}
        </Button>

        <CopyToClipboard text={c.url} onCopy={() => setCopied(true)}>
          <Button
            className="btn-icon-clipboard ml-0"
            style={{ paddingTop: '20px', paddingBottom: '20px' }}
          >
            <div>
              {copied ? (
                <>
                  <ClipboardCheck size={23} className="mr-3" /> {t('default.copied', 'Kopierad')}
                </>
              ) : (
                <>
                  <Link45deg size={28} className="mr-3" />{' '}
                  {t('material.copy-link', 'Kopiera direktlänk')}
                </>
              )}
            </div>
          </Button>
        </CopyToClipboard>
      </Col>
    </Row>
  );
}
